import React from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Button from 'src/Components/Button'
import { If } from 'src/Components/Conditionals'
import LogoWithMessage from 'src/Components/Error/LogoWithMessage'
import AddressAlreadyExists from 'src/Components/Error/AddressAlreadyExists'
import TimeoutMessage from 'src/Components/Error/TimeoutMessage'
import DefaultMessage from 'src/Components/Error/DefaultMessage'
import {
  selectCreateHomeTimeout,
  selectAddressAlreadyExistsError
} from 'src/store/selectors/home/homeCreate'
import { selectCustomerFirstName } from 'src/store/selectors/customerProfile'

import styles from './CreateHomeError.module.scss'

const propTypes = {
  className: PropTypes.string
}

const CreateHomeError = ({ className, onClick, ...restProps }) => {
  const firstName = useSelector(selectCustomerFirstName)
  const timeout = useSelector(selectCreateHomeTimeout)
  const alreadyExists = useSelector(selectAddressAlreadyExistsError)

  return (
    <div className={classnames(styles.root, className)} {...restProps}>
      <LogoWithMessage>
        <If condition={timeout}>
          <TimeoutMessage />
        </If>
        <If condition={!timeout}>
          <If condition={alreadyExists}>
            <AddressAlreadyExists firstName={firstName} />
          </If>
          <If condition={!alreadyExists}>
            <DefaultMessage />
          </If>
        </If>
      </LogoWithMessage>

      <Button primary onClick={onClick} data-qa='createHome-restart'>
        <FormattedMessage
          id='CreateHome.button.tryAgain'
          defaultMessage='Try again'
        />
      </Button>
    </div>
  )
}

CreateHomeError.propTypes = propTypes

export default CreateHomeError
